import Icon from '../components/Icon.vue'

Icon.register({
  socks: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M214.7 311c-52.7 39.6-69 110-39.2 165.4l-21.9 16.4c-17.3 13-37.5 19.2-57.5 19.2-32.8 0-65.7-16.8-83.9-48.3-24.6-42.6-10.2-97.5 29.2-127.1l86.7-64.6v-176h160v160zM288 32v32h-160v-32c0-17.7 14.3-32 32-32h128c2.8 0 5.4 0.9 8 1.6-4.9 9.1-8 19.3-8 30.4zM480 0c17.7 0 32 14.3 32 32v32h-192v-32c0-17.7 14.3-32 32-32h128zM320 272v-176h192v208 0c0 35.3-22.9 81.2-51.2 102.4l-115.2 86.4c-17.3 13-37.5 19.2-57.5 19.2-32.8 0-65.2-16.8-83.4-48.3-24.7-42.6-10.2-97.5 29.2-127.1z'
      }
    ]
  }
})
